import { render, staticRenderFns } from "./newsletterE.vue?vue&type=template&id=8848e30c"
import script from "./newsletterE.vue?vue&type=script&lang=js"
export * from "./newsletterE.vue?vue&type=script&lang=js"
import style0 from "./newsletterE.vue?vue&type=style&index=0&id=8848e30c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports